import { FC } from 'react';
import { SelectChangeEvent } from '@mui/material';
import { Nullable, IssueTypeField, JiraTicket } from 'common-types';
import DynamicField from './DynamicField';

const CreateJiraTicketDynamicFields: FC<
  React.PropsWithChildren<CreateJiraTicketDynamicFieldsProps>
> = ({
  dynamicTypeFieldsMetadata,
  validationObject,
  jiraTicketFields,
  onDynamicFieldChange,
}) => {
  return dynamicTypeFieldsMetadata?.length ? (
    <>
      {dynamicTypeFieldsMetadata.map(field => {
        return (
          <DynamicField
            key={field.key}
            field={field}
            jiraTicketFields={jiraTicketFields}
            validationObject={validationObject}
            onDynamicFieldChange={onDynamicFieldChange}
          />
        );
      })}
    </>
  ) : null;
};
export interface CreateJiraTicketDynamicFieldsProps {
  dynamicTypeFieldsMetadata: Nullable<IssueTypeField[]>;
  validationObject: Nullable<{
    [key: string]: {
      message: string;
    };
  }>;
  jiraTicketFields: JiraTicket;
  onDynamicFieldChange: (
    e: SelectChangeEvent<{
      value: string;
      id: string;
    }>,
  ) => void;
}

export default CreateJiraTicketDynamicFields;
